<div *ngIf="data" class="widget-container">
    <div class="header">
        {{ data.title }}
    </div>
    <div class="loading-content" *ngIf="!dataProcessed">
        <lib-loading></lib-loading>
    </div>
    <p class="no-activities-label" *ngIf="dataProcessed && emptyActivities">Nenhuma atividade encontrada.</p>
    <div class="schedule-container" *ngIf="dataProcessed && !emptyActivities">
        <div class="schedule-content">
            <div class="section-control" (click)="expandSection(0)">
                <p>Atividades de hoje ({{ activities.today.facs.length }})</p>
                <img src="./assets/svgs/arrow_down_ico.svg" alt="arrow down" *ngIf="expandedSection === 0">
                <img src="./assets/svgs/arrow_right_ico.svg" alt="arrow right" *ngIf="expandedSection !== 0">
            </div>
            <p class="no-facs" *ngIf="expandedSection === 0 && activities.today.facs.length === 0">
                Não existe atividade
            </p>
            <div class="schedule-activity" *ngIf="expandedSection === 0 && activities.today.facs.length > 0">
                <div class="activity-facs" *ngFor="let fac of activities.today.facs" (click)="toggleFacModal(fac, activitiesEnum.Today)">
                    <div class="fac-display">
                        <div class="fac-display-temp" [ngClass]="{'green': fac.color === 1, 'red': fac.color === 2, 'yellow': fac.color === 3}"></div>
                        <div class="fac-display-data">
                            <span>{{ fac.name }}</span>
                            <span>{{ fac.return_date ? 'Retorno: ' + (formatDateToStringDescription(fac.return_date)) : '' }}{{ fac.visit_date ? 'Visita: ' + (fac.visit_date | date:'dd/MM/yy HH:mm') : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-control" (click)="expandSection(1)">
                <p>Atividades de amanhã ({{ activities.tomorrow.facs.length }})</p>
                <img src="./assets/svgs/arrow_down_ico.svg" alt="arrow down" *ngIf="expandedSection === 1">
                <img src="./assets/svgs/arrow_right_ico.svg" alt="arrow right" *ngIf="expandedSection !== 1">
            </div>
            <p class="no-facs" *ngIf="expandedSection === 1 && activities.tomorrow.facs.length === 0">
                Não existe atividade
            </p>
            <div class="schedule-activity" *ngIf="expandedSection === 1 && activities.tomorrow.facs.length > 0">
                <div class="activity-facs" *ngFor="let fac of activities.tomorrow.facs" (click)="toggleFacModal(fac, activitiesEnum.Tomorrow)">
                    <div class="fac-display">
                        <div class="fac-display-temp" [ngClass]="{'green': fac.color === 1, 'red': fac.color === 2, 'yellow': fac.color === 3}"></div>
                        <div class="fac-display-data">
                            <span>{{ fac.name }}</span>
                            <span>{{ fac.return_date ? 'Retorno: ' + (formatDateToStringDescription(fac.return_date)) : '' }}{{ fac.visit_date ? 'Visita: ' + (fac.visit_date | date:'dd/MM/yy HH:mm') : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-control" (click)="expandSection(2)">
                <p>Atividades dos próximos dias ({{ activities.next_days.facs.length }})</p>
                <img src="./assets/svgs/arrow_down_ico.svg" alt="arrow down" *ngIf="expandedSection === 2">
                <img src="./assets/svgs/arrow_right_ico.svg" alt="arrow right" *ngIf="expandedSection !== 2">
            </div>
            <p class="no-facs" *ngIf="expandedSection === 2 && activities.next_days.facs.length === 0">
                Não existe atividade
            </p>
            <div class="schedule-activity" *ngIf="expandedSection === 2 && activities.next_days.facs.length > 0">
                <div class="activity-facs" *ngFor="let fac of activities.next_days.facs" (click)="toggleFacModal(fac, activitiesEnum.NextDays)">
                    <div class="fac-display">
                        <div class="fac-display-temp" [ngClass]="{'green': fac.color === 1, 'red': fac.color === 2, 'yellow': fac.color === 3}"></div>
                        <div class="fac-display-data">
                            <span>{{ fac.name }}</span>
                            <span>{{ fac.return_date ? 'Retorno: ' + (formatDateToStringDescription(fac.return_date)) : '' }}{{ fac.visit_date ? 'Visita: ' + (fac.visit_date | date:'dd/MM/yy HH:mm') : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-control" (click)="expandSection(3)">
                <p>Atividades vencidas ({{ activities.past.facs.length }})</p>
                <img src="./assets/svgs/arrow_down_ico.svg" alt="arrow down" *ngIf="expandedSection === 3">
                <img src="./assets/svgs/arrow_right_ico.svg" alt="arrow right" *ngIf="expandedSection !== 3">
            </div>
            <p class="no-facs" *ngIf="expandedSection === 3 && activities.past.facs.length === 0">
                Não existe atividade
            </p>
            <div class="schedule-activity" *ngIf="expandedSection === 3 && activities.past.facs.length > 0">
                <div class="activity-facs" *ngFor="let fac of activities.past.facs" (click)="toggleFacModal(fac, activitiesEnum.Past)">
                    <div class="fac-display">
                        <div class="fac-display-temp" [ngClass]="{'green': fac.color === 1, 'red': fac.color === 2, 'yellow': fac.color === 3}"></div>
                        <div class="fac-display-data">
                            <span>{{ fac.name }}</span>
                            <span>{{ fac.return_date ? 'Retorno: ' + (formatDateToStringDescription(fac.return_date)) + '' : '' }}{{ fac.visit_date ? 'Visita: ' + (fac.visit_date | date:'dd/MM/yy HH:mm') : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-edit-fac-modal *ngIf="showFacModal" [show]="showFacModal" [facdId]="showFacId" [columnType]="showFacFunnelStage" (closeM)="toggleFacModal()"></app-edit-fac-modal>
